import { Component, OnInit } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';
import { cities } from './cities';

@Component({
  selector: 'app-city',
  templateUrl: './app-city.component.html',
})

export class AppCityComponent extends FieldComponent implements OnInit {

  departaments = Object.keys(cities).map(key => cities[key]);
  cities = [];
  override start() {
    super.start();
    this.field.getValue() || this.field.setValue([]);
  }

  onChooseDept() {
    this.cities = cities[this.value[0]]?.cities;
    this.updateObject();
    this.onChangeContent();
  }
}
